import {
  ChangeRoleIcon_default
} from "./chunk-NFOXRCO6.mjs";
export {
  ChangeRoleIcon_default as default
};
